<template>
  <div class="animated fadeIn">
    <b-card header-tag="header">
      <div slot="header">
        <i class="fa fa-money"></i> Pagamentos
        <b-link :to="`${actionUri}/new/`" class="btn mr-2 btn-sm btn-primary float-right">
          <i class="fa fa-plus"></i>
          Retirada
        </b-link>
      </div>
      <b-card-body>
        <div class="form-row justify-content-start">
          <template v-if="$auth.isPartner || $auth.isFinance">            
            <div class="col-sm-3" v-if="isMoneyOutGroupButtonEnabled">
              <div class="form-group">
                <label>Remessa</label>
                <model-list-select
                  :list="moneyOutGroup.data"
                  option-value="id"
                  option-text="name"
                  v-model="moneyOutGroup.selected"
                  placeholder="Digite o nome da remessa"
                  @searchchange="searchMoneyOutGroup"
                ></model-list-select>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label>Empresa</label>
                <model-list-select
                  v-if="$auth.isPartner"
                  :list="sellers.data"
                  option-value="id"
                  option-text="name"
                  v-model="sellers.selected"
                  placeholder="Digite o nome da empresa"
                  @searchchange="searchSellers"
                ></model-list-select>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label>Representante</label>
                <model-list-select
                  :list="salesPeople.data"
                  option-value="id"
                  option-text="name"
                  v-model="salesPeople.selected"
                  placeholder="Digite o nome do representante"
                  @searchchange="searchSalesPeople"
                ></model-list-select>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label>Status</label>
                <select :class="{'custom-select': true}" v-model="moneyOutStatus.selected">
                  <option
                    v-for="(s, index) in moneyOutStatus.data"
                    :key="index"
                    :value="s.id"
                  >{{s.name}}</option>
                </select>
              </div>
            </div>
          </template>
          <template v-else>
            <!-- <div class="col-sm-3">
              <div class="form-group">
                <label>Remessa</label>
                <model-list-select
                  :list="moneyOutGroup.data"
                  option-value="id"
                  option-text="name"
                  v-model="moneyOutGroup.selected"
                  placeholder="Digite o nome da remessa"
                  @searchchange="searchMoneyOutGroup"
                ></model-list-select>
              </div>
            </div> -->
            <div class="col-sm-3">
              <div class="form-group">
                <label>{{$auth.isSalesPerson ? "Representante": "Empresa"}}</label>
                <input
                  disabled
                  type="text"
                  style="font-weight: bold !important;"
                  class="form-control-plaintext"
                  v-model="$auth.customerName"
                />                
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label>Status</label>
                <select :class="{'custom-select': true}" v-model="moneyOutStatus.selected">
                  <option
                    v-for="(s, index) in moneyOutStatus.data"
                    :key="index"
                    :value="s.id"
                  >{{s.name}}</option>
                </select>
              </div>
            </div>
          </template>
        </div>
        <div class="form-row justify-content-start">
          <!-- <div class="col-md-3">
                  <div class="form-group">
                    <label>Tipo</label>
                    <select :class="{'custom-select': true}" v-model="paymentType.selected">
                      <option v-for="(s, index) in paymentType.data" :key="index" :value="s.value">
                        {{s.text}}
                      </option>
                    </select>
                  </div>
          </div>-->          
          <!-- <div class="col-sm-2">
            <div class="form-group">
              <label>Data Agendamento</label>
              <datepicker
                :clear-button="true"
                :language="languages.ptBR"
                :bootstrapStyling="true"
                placeholder="Data agendamento"
                :calendar-button="true"
                calendar-button-icon="fa fa-calendar"
                v-model="scheduleDate"                
              ></datepicker>
            </div>
          </div> -->
          <div class="col-sm-2">
            <div class="form-group">
              <label>Início</label>
              <datepicker
                :language="languages.ptBR"
                :bootstrapStyling="true"
                placeholder="Início"
                :calendar-button="true"
                calendar-button-icon="fa fa-calendar"
                v-model="startDate"
              ></datepicker>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">  
              <label>Horario</label>
              <div>
                <vue-timepicker input-class="form-control" v-model="startHour" format="HH:mm:ss"></vue-timepicker>
              </div>          
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label>Término</label>
              <datepicker
                :language="languages.ptBR"
                :bootstrapStyling="true"
                placeholder="Termino"
                :calendar-button="true"
                calendar-button-icon="fa fa-calendar"
                v-model="endDate"
              ></datepicker>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">  
              <label>Horario</label>
              <div>
                <vue-timepicker input-class="form-control" v-model="endHour" format="HH:mm:ss"></vue-timepicker>
              </div>              
            </div>
          </div>
          <!-- <div class="col-md-3">
                  <div class="form-group">
                    <label>Data Pagamento</label>
                    <datepicker :clear-button="true" :language="languages.ptBR" :bootstrapStyling="true" placeholder="Data pagamento" :calendar-button="true" calendar-button-icon="fa fa-calendar" v-model="endedDate"></datepicker>
                  </div>
          </div>-->
        </div>
        <b-row>
          <b-col md="6" class="my-1">
            <b-form-group label-cols-sm="0" label class="mb-0">
              <b-input-group>
                <b-input-group-append>
                  <b-button @click="searchPayments" variant="primary">Buscar</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card>
      <div class="row">
        <div class="col-md-3 col-sm-12">
          <div class="callout">
            <small class="text-muted">
              Total
              <br />Pagamentos
            </small>
            <h4 class="h4">{{totalPayments}}</h4>
          </div>
        </div>
        <div class="col-md-3 col-sm-12">
          <div class="callout">
            <small class="text-muted">
              Total
              <br />Transferências
            </small>
            <h4 class="h4">{{totalTransfers}}</h4>
          </div>
        </div>
        <div class="col-md-3 col-sm-12">
          <div class="callout">
            <small class="text-muted">
              Total
              <br />Boletos
            </small>
            <h4 class="h4">{{totalBillPayments}}</h4>
          </div>
        </div>
        <div class="col-md-3 col-sm-12">
          <div class="callout">
            <small class="text-muted">
              Total
              <br />Saques
            </small>
            <h4 class="h4">{{totalWithDrawals}}</h4>
          </div>
        </div>
      </div>
    </b-card>
    <b-card>
      <b-row class="float-right" v-if="$auth.isPartner || $auth.isFinance">
        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="0" label class="mb-0">
            <b-input-group>
                <b-input-group-append>
                    <b-dropdown id="dropdown-1" text="Ações" variant="primary">
                        <b-dropdown-item v-if="isMoneyOutGroupButtonEnabled" @click="createMoneyOutGroup">Gerar Remessa</b-dropdown-item>
                        <b-dropdown-item @click="exportToExcel">Exportar</b-dropdown-item>                            
                    </b-dropdown>                                          
                </b-input-group-append>
            </b-input-group>           
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        :items="result.data"
        :fields="fields"
        :striped="true"
        responsive
        ref="selectableTable"        
      >
      <template slot="HEAD_selected">
        <b-form-checkbox v-if="isMoneyOutGroupButtonEnabled" @change="selectAllItems" :checked="selectAll"></b-form-checkbox>
      </template>
      <template slot="selected" slot-scope="data">
        <b-form-checkbox v-if="isMoneyOutGroupButtonEnabled" :disabled="data.item.status != 'PENDING' && data.item.moneyOutGroupId != ''" @change="selectedItemsChanged" name="selected-items" v-model="selectedItems" :value="data.item">
        </b-form-checkbox>
      </template>
      <template slot="amount" slot-scope="data">{{formatDecimalFields(data.value)}}</template>
      <template slot="status" slot-scope="data">{{bindStatusName(data.value)}}</template>
      <template slot="customerType" slot-scope="data">{{bindBusinessTypeName(data.value)}}</template>
      <template slot="scheduledDate" slot-scope="data">{{formatDateTimeFields(data.value)}}</template>
      <template slot="endedAt" slot-scope="data">{{formatDateTimeFields(data.value)}}</template>
      <template slot="type" slot-scope="data">{{getMoneyOutType(data.value)}}</template>
      <template slot="actions" slot-scope="row">        
        <button v-show="actionUri != ''" @click.prevent="onCustomActionClick('remove', row)" class="btn mr-2 btn-md btn-primary action-btn">
          <i class="fa fa-edit"></i>
        </button>        
      </template>
      </b-table>
      <nav>
        <b-pagination
          :total-rows="result.rowCount"
          :per-page.sync="result.pageSize"
          v-model="currentPage"
          prev-text="Voltar"
          next-text="Próximo"
          @change="pageIndexChanged"
          first-text="Primeiro"
          last-text="Último"
        />
    </nav>
    </b-card>
    <b-modal
      id="modal-export-selector"
      ref="modal"
      title="Gerar remessa"
      ok-title="Salvar"
      @ok="handleOk"
      v-model="showExportSelectorModal"
      :ok-disabled="exportButtonModalDisabled"
      :cancel-disabled="exportButtonModalDisabled"
    >
      <div
        class="alert alert-danger"
        role="alert"
        v-show="exportErrorModal"
      >{{exportErrorMessage}}</div>
      <form ref="form">
        <div class="form-row">
          <div class="col-sm-12">
            <div class="form-group" >
              <label for="exampleFormControlSelect1">{{ isMoneyOutGroupBanksEnabled ? "Escolha o banco" : "Deseja realmente criar uma remessa para os pagamentos selecionados?" }}</label>
              <select v-show="isMoneyOutGroupBanksEnabled" :class="{'custom-select': true}" v-model="selectedExportType">
                <option v-for="(s, index) in exportTypeList" :key="index" :value="s.id">{{s.name}}</option>
              </select>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<style>
  .vue__time-picker input.display-time {
    height: 35px !important;
  }
</style>
<script>
import cTable from "../../../components/base/Table.vue";
import domainService from "../../../services/MoneyFlow/moneyOutService";
import moneyOutGroupService from "../../../services/MoneyFlow/moneyOutGroupService";
import sellerService from "../../../services/Customer/sellerService";
import salesPersonService from "../../../services/Customer/salesPersonService";
import helperService from "../../../services/Helper/helperService";
import listPage from "../../../mixins/listPage";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import { ModelListSelect } from "vue-search-select";
import { getDateDayBefore } from "../../../shared/utils";
import moment from 'moment';
import config from "../../../config";
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
export default {
  components: {
    cTable,
    Datepicker,
    ModelListSelect,
    VueTimepicker
  },
  mixins: [listPage],
  data() {
    return {
      exportErrorModal: false,
      exportErrorMessage: '',
      showExportSelectorModal: false,
      exportButtonModalDisabled: false,
      selectedExportType: 341,
      exportTypeList: [
        { id: 341, name: "Itaú", },
        { id: 237, name: "Bradesco", }
      ],            
      languages: lang,
      actionUri: "/partners/payments",
      startDate: getDateDayBefore(new Date(), 7),
      startHour: '00:00:00',
      endDate: new Date(),
      endHour: '23:59:59',
      endedDate: null,
      scheduleDate: null,
      bankCode: null,
      bankList: [],
      summary: {
        total: 0,
        totalBillPayments: 0,
        totalTransfers: 0,
        totalWithDrawals: 0,
      },
      fields: [
        { key: 'selected', label: 'Selecionar'},
        { key: "scheduledDate", label: "Data Agendada", sortable: false },
        { key: "customerDocument", label: "Doc.", sortable: false },
        { key: "customerName", label: "Empresa / Representante", sortable: false },
        { key: "status", label: "Status", sortable: false },        
        { key: "endedAt", label: "Data Pagto.", sortable: false },
        { key: "amount", label: "Valor", sortable: false },
        { key: "type", label: "Tipo", sortable: false },
        { key: "authorizationCode", label: "Cod. Aut.", sortable: false },
        { key: "actions", label: "" },
      ],      
      customActions: [
        {
          cssClass: "btn mr-2 btn-md btn-info action-btn",
          html: '<i class="fa fa-edit"></i>',
          action: "view",
        },
      ],
      sellers: {
        selected: null,
        data: [],
        query: "",
      },
      salesPeople: {
        selected: null,
        data: [],
        query: "",
      },      
      moneyOutStatus: {
        selected: '',
        data: [],
      },
      moneyOutGroup: {
        selected: '',
        data: [],
      },
      currentPage: 1,
      selectedItems: [],
      selectAll: false
    };
  },
  computed: {
    isMoneyOutGroupButtonEnabled: function() {
      let enabled = config.partnersConfiguration.payments.paymentGroup.enabled;
      return enabled && this.$auth.isPartner || this.$auth.isFinance;
    },
    isMoneyOutGroupBanksEnabled: function() {
      let enabled = config.partnersConfiguration.payments.paymentGroup.enabled;
      return enabled && 
      config.partnersConfiguration.payments.paymentGroup.exportType == 'cnab' && 
      this.$auth.isPartner || this.$auth.isFinance;
    },
    totalPayments(){
      return this.summary.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    totalTransfers(){
      return this.summary.totalTransfers.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    totalBillPayments(){
      return this.summary.totalBillPayments.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    totalWithDrawals(){
      return this.summary.totalWithDrawals.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
  },
  created() {
    this.moneyOutStatus.data = domainService.getStatuses()
    this.moneyOutStatus.data.unshift({id: '', name:'Selecione:'})
    if(this.$auth.isPartner || this.$auth.isFinance) {
      this.fields.splice(this.fields.length - 1, 0, { key: "userName", label: "Usuário", sortable: false });
    }    

    this.fetchSummaryData();
  },
  methods: {
    createMoneyOutGroup() {
      if(this.selectedItems.length == 0) {
        return;
      }
      this.showExportSelectorModal = true;
    },  
    selectedItemsChanged(item) {
      if(item == null) {
        this.selectAll = false;
      }
    },
    selectAllItems(checked) {      
    	if(checked) {
        for (let index = 0; index < this.result.data.length; index++) {
          const element = this.result.data[index];
          if(element.status != 'PENDING') continue;
          const el = this.selectedItems.find(function(item) { return item.id == element.id });
          if(el == null) {
            this.selectedItems.push(element);
          }
        }
      }
      else {
        for (let index = 0; index < this.result.data.length; index++) {
          const element = this.result.data[index];
          let itemIdx = this.selectedItems.indexOf(element);
          this.selectedItems.splice(itemIdx, 1);
        }
      }
      this.selectAll = checked;
    },  
    getSearchRequest() {
      return {
        sellerId: this.$auth.isSeller ? this.$auth.customerId : this.sellers.selected == null ? '' : this.sellers.selected,
        salesPersonId: this.$auth.isSalesPerson ? this.$auth.customerId : this.salesPeople.selected == null ? '' : this.salesPeople.selected,
        bankCode: '',
        type: '',
        status: this.moneyOutStatus.selected,
        scheduledDate: this.scheduleDate == null ? '' : this.scheduleDate,
        endedDate: this.endedDate == null ? '' : this.endedDate,
        keywords: this.keywords,
        startDate: this.startDate == null ? '' : this.formatDate(this.startDate, this.startHour),
        endDate: this.endDate == null ? '' : this.formatDate(this.endDate, this.endHour),
        moneyOutGroupId: this.moneyOutGroup.selected
      }
    },
    formatDate(date, hour) {
      let d = moment(date).format('YYYY-MM-DD');
      let f = moment(`${d} ${hour}`).toDate();
      return f;
    },
    pageIndexChanged(page) {
      this.currentPage = page;
      this.fetchData(page);
    },
    searchPayments() {
      this.fetchData(1)
      this.fetchSummaryData()
      return false
    },
    fetchSummaryData() {
      const self = this;
      self.showLoading();
      domainService
        .summary(this.getSearchRequest())
        .then(
          (response) => {
            self.summary = response.data;
            self.hideLoading();
          },
          (error) => {
            self.hideLoading();
          }
        );
    },
    fetchData(page) {
      const self = this;
      self.showLoading();
      domainService
        .findAll(
          this.getSearchRequest()
          ,
          page
        )
        .then(
          (response) => {
            if (response.status == 204) {
              self.$data.result = self.getEmptyResult();              
            } else {
              self.$data.result = response.data;              
            }
            self.selectAll = false;
            self.hideLoading();
          },
          (error) => {
            self.selectAll = false;
            self.hideLoading();
          }
        );
    },
    exportToExcel() {
      const self = this;
      this.showLoading();
      domainService.findAllExport(this.getSearchRequest()).then(
        (response) => {
          window.open(response);
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      );      
    },
    searchSellers(newQuery) {
      if (newQuery.length < 2) return;
      const self = this;
      this.showLoading();
      sellerService.all(newQuery).then(
        (response) => {
          self.sellers.data = response.status == 204 ? [] : response.data;
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      );
    },
    searchSalesPeople(q) {
      if (q == null || q.length < 2) return;
      const self = this;
      this.showLoading();
      salesPersonService.all(q, '').then(
        (response) => {
          self.salesPeople.data = response.status == 204 ? [] : response.data;
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      );
    },
    searchMoneyOutGroup(q) {
      if (q == null || q.length < 2) return;
      const self = this;
      this.showLoading();
      moneyOutGroupService.all(q).then(
        (response) => {
          self.moneyOutGroup.data = response.status == 204 ? [] : response.data;
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      )
    },
    searchBanks() {
      const self = this
      this.showLoading()
      helperService.banksGetList().then(
        (response) => {
          self.bankList = response.status == 204 ? [] : response.data
          self.bankList.unshift({ COMPE: null, LongName: 'Selecione um banco'})
          self.hideLoading()
        },
        () => {
          self.hideLoading()
        }
      );
    },
    onCustomActionClick(action, row) {
      this.$router.push({
        path: this.actionUri.concat(`/view/${row.item.type.toLowerCase()}/${row.item.id}`),
      });
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.exportErrorModal = false;
      this.exportErrorMessage = '';
      this.handleSubmit();
    },
    handleSubmit() {
      const self = this;
      this.exportButtonModalDisabled = true;
      moneyOutGroupService.create({
        name: 'Remessa',
        bankCode: this.isMoneyOutGroupBanksEnabled ? new String(this.selectedExportType) : "",
        moneyOuts: this.selectedItems.map(function(el) { return el.id })
      }).then(
        response => {
          self.selectedItems = [];
          self.selectAll =  false;
          self.fetchData(1);
          // Hide the modal manually
          self.$nextTick(() => {
            self.$refs.modal.hide();
            this.exportButtonModalDisabled = false;
          });
        },
        error => {
          self.exportErrorMessage =
            "Ocorreu um erro ao criar a remessa.";
          self.exportErrorModal = true;
          this.exportButtonModalDisabled = false;
        }
      );
    },
    formatDateTimeFields(value) {
      return value == null || value == '' ? '' : moment(value).format('DD/MM/YYYY - HH:mm:ss');
    },
    getMoneyOutType(value) {
      switch (value) {
          default:
          case "WITHDRAW":
            return "Saque";
          case "BILLPAYMENT":
            return "Boleto";
          case "BANKTRANSFER":
            return "Transferência";
            case "PIXTRANSFER":
            return "Pix";
      }
    },
    formatDecimalFields(value) {
      return value == null || value == '' ? 'R$ 0,00' : value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    bindBusinessTypeName(value) {
      switch(value.toUpperCase())
      {
        case 'SELLER':
          return 'Empresa';
        case 'SALESPERSON':
          return 'Representante';
        case 'Partner':
            'Administrador';
      }
    },
    bindStatusName(value) {
      switch(value.toUpperCase()) {
        case 'CREATED':
          return 'Criado';
        case 'PROCESSING':
          return 'Processando';
        case 'CANCELED':
          return 'Cancelado';
        case 'PENDING':
          return 'Pendente';
        case 'ANALYSIS':
          return 'Em análise';
        case 'DONE':
          return 'Finalizado';
      }
    }
  },
};
</script>
